document.addEventListener('DOMContentLoaded', function () {
   const body = document.querySelector('body');

   function openModal(modal) {
      modal.classList.add('is-active');
      body.classList.add('overflow-hidden');

      console.log(body.classList.contains('overflow-hidden'));
   }

   function closeModal(modal) {
      modal.classList.remove('is-active');

      if (!document.querySelector('.wcl-modal.is-active')) {
         body.classList.remove('overflow-hidden');
      }
   }

   document.querySelectorAll('.js-open-modal').forEach(function (button) {
      button.addEventListener('click', function (e) {
         e.preventDefault();

         const modal = document.getElementById(this.dataset.modal);

         if (!modal) return;

         openModal(modal);
      });
   });

   document.querySelectorAll('.wcl-modal').forEach(function (modal) {
      modal.addEventListener('click', function (e) {
         if (
            e.target === modal ||
            e.target.classList.contains('wcl-modal__wrapper') ||
            e.target.closest('.js-modal-close')
         ) {
            closeModal(modal);
         }
      });
   });

   document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
         document.querySelectorAll('.wcl-modal.is-active').forEach(closeModal);
      }
   });
});